// tslint:disable:no-submodule-imports
import * as faArrowDown from '@fortawesome/fontawesome-free-solid/faArrowDown';
import * as faArrowUp from '@fortawesome/fontawesome-free-solid/faArrowUp';
import * as faChartLine from '@fortawesome/fontawesome-free-solid/faChartLine';
import * as faTrash from '@fortawesome/fontawesome-free-solid/faTrash';
// tslint:enable:no-submodule-imports
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import autobind from 'class-autobind';
import * as classNames from 'classnames';
import * as React from 'react';
import { Button, ButtonGroup, ButtonToolbar } from 'reactstrap';
import {
    CustomStreamType,
    MoveActivityStreamProps,
    MoveDirection,
    RemoveActivityStreamProps,
    SelectActivityStreamProps,
    StravaStreamType
} from '../../types';

export type ActivityChartControlsProps = {
    error?: any;
    isBottomItem: boolean;
    isEmpty: boolean;
    isSelected: boolean;
    isTopItem: boolean;
    loading?: boolean;
    name: string;
    type: StravaStreamType | CustomStreamType | null;
} & SelectActivityStreamProps &
    RemoveActivityStreamProps &
    MoveActivityStreamProps;

export default class ActivityChartControls extends React.Component<
    ActivityChartControlsProps,
    { dropdownOpen: boolean }
> {
    constructor(props: ActivityChartControlsProps) {
        super(props);

        autobind(this);
    }

    public render() {
        const {
            error,
            name,
            isEmpty,
            isSelected,
            isTopItem,
            isBottomItem,
            loading
        } = this.props;

        return (
            <div className="chart-controls">
                <h5
                    className={classNames({
                        'text-muted': isEmpty || error
                    })}
                >
                    {name}
                </h5>
                <ButtonGroup>
                    <Button
                        className={classNames({
                            disabled: isSelected || loading
                        })}
                        color={'link'}
                        active={isSelected}
                        size="sm"
                        onClick={this.handleSelectActivityStream}
                        disabled={isSelected || loading || error}
                    >
                        {' '}
                        <FontAwesomeIcon
                            className="mr-1 d-md-none d-lg-inline"
                            icon={faChartLine}
                        />
                        Show on map
                    </Button>
                    <Button
                        color="link"
                        size="sm"
                        disabled={!isSelected || loading || error}
                        onClick={this.handleHideActivityStream}
                    >
                        Hide
                    </Button>
                </ButtonGroup>
                <ButtonToolbar className="w-100">
                    <ButtonGroup className="">
                        <Button
                            className=""
                            color="secondary"
                            outline={true}
                            size="sm"
                            disabled={isBottomItem || loading || error}
                            onClick={this.handleMoveDown}
                        >
                            <FontAwesomeIcon icon={faArrowDown} className="" />
                        </Button>
                        <Button
                            color="secondary"
                            outline={true}
                            size="sm"
                            disabled={isTopItem || loading || error}
                            onClick={this.handleMoveUp}
                        >
                            <FontAwesomeIcon icon={faArrowUp} className="" />
                        </Button>
                    </ButtonGroup>
                    <Button
                        className="ml-2"
                        color="secondary"
                        outline={true}
                        size="sm"
                        disabled={loading || error}
                        onClick={this.handleRemoveActivityStream}
                    >
                        <FontAwesomeIcon icon={faTrash} className="" />
                    </Button>
                </ButtonToolbar>
            </div>
        );
    }

    private handleSelectActivityStream(e: React.MouseEvent<any>) {
        const { selectActivityStream, type } = this.props;
        e.stopPropagation();
        selectActivityStream && type && selectActivityStream(type);
    }

    private handleHideActivityStream(e: React.MouseEvent<any>) {
        const { selectActivityStream } = this.props;
        e.stopPropagation();
        selectActivityStream && selectActivityStream();
    }

    private handleRemoveActivityStream(e: React.MouseEvent<any>) {
        const { removeActivityStream, type } = this.props;
        e.stopPropagation();
        removeActivityStream && type && removeActivityStream(type);
    }

    private handleMoveUp(e: React.MouseEvent<any>) {
        e.stopPropagation();
        this.handleMoveActivityStream(MoveDirection.up);
    }

    private handleMoveDown(e: React.MouseEvent<any>) {
        e.stopPropagation();
        this.handleMoveActivityStream(MoveDirection.down);
    }

    private handleMoveActivityStream(direction: MoveDirection) {
        const { moveActivityStream, type } = this.props;
        moveActivityStream && type && moveActivityStream(type, direction);
    }
}



// WEBPACK FOOTER //
// ./src/client/components/Strava/ActivityScene/ActivityChart/ActivityChartControls.tsx